//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

import React, { useEffect } from "react";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { MdCamera } from "react-icons/md";
import Link from "@material-ui/core/Link";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Button from "@material-ui/core/Button";
import IndividualCategory from "./IndividualCategory";
import { architectureURLs } from "../AllImages/architecture";
import { wallpapersURLs } from "../AllImages/wallpapers";
import { birdsURLs } from "../AllImages/birds";
import { compositionURLs } from "../AllImages/composition";
import { geometryURLs } from "../AllImages/geometry";
import { landscapeURLs } from "../AllImages/landscape";
import { manipulationURLs } from "../AllImages/manipulation";
import { moonURLs } from "../AllImages/moon";
import { portraitURLs } from "../AllImages/portrait";
import { streetURLs } from "../AllImages/street";
import { travelURLs } from "../AllImages/travel";

//......keep this import at last......
import { useStyles } from "./Styles";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const GlobalCss = withStyles({
  "@global": {
    ".MuiGrid-grid-lg-3": {
      maxWidth: "20%",
    },
    ".MuiGrid-grid-md-3": {
      maxWidth: "25%",
    },
    ".MuiGrid-grid-sm-6": {
      maxWidth: "38%", // changed from 40 to 30
    },
    // ".MuiGrid-grid-xs-6": {
    //   maxWidth: "36%",
    // },
    ".MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      padding: "19px", //changed from 12 to 19
    },
    ".MuiGrid-spacing-xs-4": {
      margin: "0", // changed from 4 to 0
    },
  },
})(() => null);
function Gallery() {
  const classes = useStyles();

  const [typeSelected, setType] = React.useState("");
  const [aboutType, setAbout] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [countFor, setCountFor] = React.useState("");
  const [totalCount, setTotal] = React.useState({
    Street: "",
    Portraits: "",
    Travel: "",
    Moon: "",
    Composition: "",
    Birds: "",
    Geometry: "",
    Manipulations: "",
    Landscapes: "",
    Architecture: "",
    Wallpapers: "",
  });

  function handleModal(type) {
    setType(type);
    if (type === "Street") {
      setAbout(`"One where I interact with humans with heart"`);
      setCountFor(totalCount.Street);
    } else if (type === "Portraits") {
      setAbout(`"Here you will see various versions of hoomans"`);
      setCountFor(totalCount.Portraits);
    } else if (type === "Travel") {
      setAbout(`"All in one medicine for travellers, atleast for me :P"`);
      setCountFor(totalCount.Travel);
    } else if (type === "Moon & Space") {
      setAbout(`"For those who loves night life like me"`);
      setCountFor(totalCount.Moon);
    } else if (type === "Composition") {
      setAbout(`"Where I framed subject, background and foreground"`);
      setCountFor(totalCount.Composition);
    } else if (type === "Birds & Nature") {
      setAbout(`"For nature lovers"`);
      setCountFor(totalCount.Birds);
    } else if (type === "Geometry") {
      setAbout(`"Perspective that gives satisfaction"`);
      setCountFor(totalCount.Geometry);
    } else if (type === "Manipulations") {
      setAbout(`"Where I play with images at various levels"`);
      setCountFor(totalCount.Manipulations);
    } else if (type === "Landscapes") {
      setAbout(`"Wider perspective to see heaven"`);
      setCountFor(totalCount.Landscapes);
    } else if (type === "Architecture") {
      setAbout(`"Miracles made by civil engineers"`);
      setCountFor(totalCount.Architecture);
    } else if (type === "Wallpapers") {
      setAbout(`"Special wallpaper series curated by me"`);
      setCountFor(totalCount.Wallpapers);
    }

    setOpen(true);
  }
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setTotal({
      ...totalCount,
      ["Street"]: streetURLs.length,
      ["Portraits"]: portraitURLs.length,
      ["Architecture"]: architectureURLs.length,
      ["Travel"]: travelURLs.length,
      ["Moon"]: moonURLs.length,
      ["Composition"]: compositionURLs.length,
      ["Birds"]: birdsURLs.length,
      ["Geometry"]: geometryURLs.length,
      ["Manipulations"]: manipulationURLs.length,
      ["Landscapes"]: landscapeURLs.length,
      ["Wallpapers"]: wallpapersURLs.length,
    });
  }, []);
  return (
    <React.Fragment>
      <div
        id="otherComponents"
        className={classes.otherComponents}
        style={{ overflowY: "scroll", overflowX: "hidden" }}
      >
        <div>
          <Typography
            variant="h5"
            color="inherit"
            className=""
            style={{ fontSize: "2.4vw" }}
          >
            Welcome to the world of ph
            <MdCamera
              style={{
                animationName: "spin",
                animationDuration: "4000ms",
                animationIterationCount: "infinite",
                animationTimingFunction: "linear",
              }}
            />
            tography through my eyes <br />
            <Typography
              color="textSecondary"
              variant="caption"
              // style={{ fontSize: "1.5vw" }}
              id="subText"
            >
              Select any category
            </Typography>
          </Typography>
        </div>

        <div id="rootOfImageGrid" className={classes.root}>
          <GlobalCss />
          <Grid container spacing={4}>
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Link
                href="#"
                color="inherit"
                onClick={() => handleModal("Wallpapers")}
              >
                <div className={classes.polaroidOuter}>
                  <img
                    className={classes.polaroidImages}
                    src="images/categoriesImages/wallpaper.jpg"
                    alt=""
                  />
                  <Typography
                    variant="caption"
                    className={classes.polaroidText}
                    style={{ fontSize: "3vh 1.8vw" }}
                  >
                    Wallpapers ({totalCount.Wallpapers})
                  </Typography>
                </div>
              </Link>
            </Grid>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Link
                href="#"
                color="inherit"
                onClick={() => handleModal("Portraits")}
              >
                <div className={classes.polaroidOuter}>
                  <img
                    className={classes.polaroidImages}
                    src="images/categoriesImages/portraits.jpg"
                    alt=""
                  />
                  <Typography
                    variant="caption"
                    className={classes.polaroidText}
                    style={{ fontSize: "3vh 1.8vw" }}
                  >
                    Portraits ({totalCount.Portraits})
                  </Typography>
                </div>
              </Link>
            </Grid>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Link
                href="#"
                color="inherit"
                onClick={() => handleModal("Composition")}
              >
                <div className={classes.polaroidOuter}>
                  <img
                    className={classes.polaroidImages}
                    src="images/categoriesImages/composition.jpeg"
                    alt=""
                  />
                  <Typography
                    variant="caption"
                    className={classes.polaroidText}
                    style={{ fontSize: "3vh 1.8vw" }}
                  >
                    Composition ({totalCount.Composition})
                  </Typography>
                </div>
              </Link>
            </Grid>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Link
                href="#"
                color="inherit"
                onClick={() => handleModal("Birds & Nature")}
              >
                <div className={classes.polaroidOuter}>
                  <img
                    className={classes.polaroidImages}
                    src="images/categoriesImages/birds.jpg"
                    alt=""
                  />
                  <Typography
                    variant="caption"
                    className={classes.polaroidText}
                    style={{ fontSize: "3vh 1.8vw" }}
                  >
                    Birds and nature ({totalCount.Birds})
                  </Typography>
                </div>
              </Link>
            </Grid>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Link
                href="#"
                color="inherit"
                onClick={() => handleModal("Landscapes")}
              >
                <div className={classes.polaroidOuter}>
                  <img
                    className={classes.polaroidImages}
                    src="images/categoriesImages/landscape.jpg"
                    alt=""
                  />
                  <Typography
                    variant="caption"
                    className={classes.polaroidText}
                    style={{ fontSize: "3vh 1.8vw" }}
                  >
                    Landscapes ({totalCount.Landscapes})
                  </Typography>
                </div>
              </Link>
            </Grid>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Link
                href="#"
                color="inherit"
                onClick={() => handleModal("Architecture")}
              >
                <div className={classes.polaroidOuter}>
                  <img
                    className={classes.polaroidImages}
                    src="images/categoriesImages/architecture.jpg"
                    alt=""
                  />
                  <Typography
                    variant="caption"
                    className={classes.polaroidText}
                    style={{ fontSize: "3vh 1.8vw" }}
                  >
                    Architecture ({totalCount.Architecture})
                  </Typography>
                </div>
              </Link>
            </Grid>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Link
                href="#"
                color="inherit"
                onClick={() => handleModal("Street")}
              >
                <div className={classes.polaroidOuter}>
                  <img
                    className={classes.polaroidImages}
                    src="images/categoriesImages/street.jpg"
                    alt=""
                  />
                  <Typography
                    variant="caption"
                    className={classes.polaroidText}
                    style={{ fontSize: "3vh 1.8vw" }}
                  >
                    Street ({totalCount.Street})
                  </Typography>
                </div>
              </Link>
            </Grid>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Link
                href="#"
                color="inherit"
                onClick={() => handleModal("Manipulations")}
              >
                <div className={classes.polaroidOuter}>
                  <img
                    className={classes.polaroidImages}
                    src="images/categoriesImages/manipulation.jpg"
                    alt=""
                  />
                  <Typography
                    variant="caption"
                    className={classes.polaroidText}
                    style={{ fontSize: "3vh 1.8vw" }}
                  >
                    Manipulations ({totalCount.Manipulations})
                  </Typography>
                </div>
              </Link>
            </Grid>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Link
                href="#"
                color="inherit"
                onClick={() => handleModal("Moon & Space")}
              >
                <div className={classes.polaroidOuter}>
                  <img
                    className={classes.polaroidImages}
                    src="images/categoriesImages/moon.jpg"
                    alt=""
                  />
                  <Typography
                    variant="caption"
                    className={classes.polaroidText}
                    style={{ fontSize: "3vh 1.8vw" }}
                  >
                    Moon and space ({totalCount.Moon})
                  </Typography>
                </div>
              </Link>
            </Grid>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <Link
                href="#"
                color="inherit"
                onClick={() => handleModal("Geometry")}
              >
                <div className={classes.polaroidOuter}>
                  <img
                    className={classes.polaroidImages}
                    src="images/categoriesImages/geometry.jpg"
                    alt=""
                  />
                  <Typography
                    variant="caption"
                    className={classes.polaroidText}
                    style={{ fontSize: "3vh 1.8vw" }}
                  >
                    Geometry ({totalCount.Geometry})
                  </Typography>
                </div>
              </Link>
            </Grid>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {/* <Grid item xs={6} sm={6} md={3} lg={3}>
              <Link
                href="#"
                color="inherit"
                onClick={() => handleModal("Travel")}
              >
                <div className={classes.polaroidOuter}>
                  <img
                    className={classes.polaroidImages}
                    src="images/categoriesImages/travel.jpg"
                    alt=""
                  />
                  <Typography
                    variant="caption"
                    className={classes.polaroidText}
                    style={{ fontSize: "3vh 1.8vw" }}
                  >
                    Travel ({totalCount.Travel})
                  </Typography>
                </div>
              </Link>
            </Grid> */}
            <br />
            <br />
          </Grid>
        </div>
      </div>
      {/*......................modal start...................*/}
      <div>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullScreen
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            {typeSelected}{" "}
            <i style={{ fontSize: "small" }}>(Total images: {countFor})</i>
          </DialogTitle>
          <DialogContent
            id="infiScroll"
            dividers
            style={{ backgroundColor: "white" }}
          >
            <Typography gutterBottom variant="capion">
              <strong>{aboutType}</strong>
              <br />
              <Typography style={{ fontSize: "0.8vw" }}>
                Picture quality is bit compromised due to compression{" "}
              </Typography>
            </Typography>
            {/*..................fetching list of photos here................*/}
            <IndividualCategory typeToRender={typeSelected} />
            {/* <IndividualCategoryV2 typeToRender={typeSelected} /> */}
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {/*......................modal ending...................*/}
    </React.Fragment>
  );
}
export default Gallery;